import React, { useState } from "react";
import about from "../../assets/image/about_nha_pg_logo.png";
import { MobileOTPServices } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import { setMobileNumber, setUuid } from "../../redux/slices/abhaSlice";

const MobileVerify = ({ setIsVerified }) => {
  const [mobile, setMobile] = useState("");
  const [patientdetail, setPatientdetail] = useState("");
  const [msg, setMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [otpGuid, setOtpGuid] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedMobile = mobile.trim();

    const isValidMobile = /^[6-9]\d{9}$/.test(trimmedMobile);

    if (isValidMobile) {
      await sendOtp();
      setMsg("");
    } else {
      setMsg(
        "Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9."
      );
    }
  };

  // const mobileLength = mobile.trim().length > 10;
  const mobileLength = mobile.length > 9;

  const sendOtp = async () => {
    setIsLoading(true);
    setError(null);
    try {
      dispatch(setMobileNumber(mobile));
      localStorage.setItem("mobile", mobile);
      localStorage.setItem("patientdetail", patientdetail);
      const body = {
        mobile: mobile,
      };

      const response = await MobileOTPServices({ body });
      console.log("OTP Send Response:", response);

      if (response?.success) {
        if (response.data?.statusCode === "0") {
          const otpData = response.data.data;
          dispatch(setUuid(otpData.otpGuid));
          if (otpData?.otpGuid) {
            setOtpGuid(otpData.otpGuid);
            localStorage.setItem("otpResponse", JSON.stringify(response));
            setOtp(["", "", "", "", "", ""]);
            setError("OTP sent successfully!");
            setIsVerified(true);
          } else {
            setError("OTP sent but technical error occurred");
            localStorage.removeItem("otpResponse");
          }
        } else {
          const errorMessage =
            response.data?.statusMessage || "Failed to send OTP";
          setError(errorMessage);

          if (response.data?.statusCode === "1") {
            setOtpGuid("");
            localStorage.removeItem("otpResponse");
          }
        }
      } else {
        setError(response?.message || "Failed to send OTP");
      }
    } catch (error) {
      setError("Failed to send OTP. Please try again.");
      localStorage.removeItem("otpResponse");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA Address and store all your medical records in one
                  place. Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA Address.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA address.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <h3>Create / Link Your ABHA</h3>
                <p className="pt-3">Verify with Your Mobile Number</p>
                <form onSubmit={handleSubmit} className="pt-4">
                  <input
                    type="tel"
                    maxLength={10}
                    pattern="[6-9]{1}[0-9]{9}"
                    placeholder="Please Enter Mobile Number."
                    value={mobile}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // allow only digits
                      setMobile(value);
                    }}
                    className="mobile-input"
                  />
                  {msg && (
                    <p
                      style={{
                        color: "#cf1f1f",
                      }}
                    >
                      {msg}
                    </p>
                  )}
                  {/* Display msg */}
                  {error && (
                    <p
                      style={{
                        color: error.includes("successfully")
                          ? "green"
                          : "#cf1f1f",
                      }}
                    >
                      {error}
                    </p>
                  )}
                  <button
                    type="submit"
                    className={`continue-btn ${
                      !mobileLength || isLoading ? "bg-disable" : ""
                    }`}
                    disabled={!mobileLength || isLoading}
                  >
                    {isLoading ? "Sending OTP..." : "Continue"}
                  </button>
                </form>
                <div className="nha-logo-container">
                  <span>APPROVED BY NHA</span>
                  <img src={about} alt="NHA Logo" className="nha-logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileVerify;
